import logo from "../assets/logo.svg"

function Banner( props: {children: string} ) {
    return (
        <div className="Banner">
            <img src={logo} width="120px" style={{marginRight: "10px"}}/>
            <h1 style={{margin: 0}}>{props.children}</h1>
        </div>
    )
}
export default Banner;